import React, { useEffect } from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe, StripeElementsOptions } from '@stripe/stripe-js';
import axios from 'axios';
import StripeForm from './StripeForm'; // The form with useStripe() inside
import {
	useStripe,
	useElements,
	PaymentElement,
} from '@stripe/react-stripe-js';
import './Stripe.css';
import { Appearance } from '@stripe/stripe-js';
import { useAppDispatch, useAppSelector } from '../../redux/hook';
import { display, selectSession } from '../../redux/slices/sessionSlice';
import { useSearchParams } from 'react-router-dom';
import {
	completeStage,
	selectStage,
	skipStage,
} from '../../redux/slices/stageSlice';
import Loading from '../../components/loading';
import useState from 'react-usestateref';
import {
	fetchPaymentPayload,
	SaveTransaction,
	StripeCreatePaymentIntent,
} from '../../redux/api';
import {
	getReservationFromPMS,
	selectTnc,
} from '../../redux/slices/termsAndConditions';
import { Stripe } from '@stripe/stripe-js';
import { ToastContainer, toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { selectPayment } from './../../redux/slices/paymentSlice';

// const stripePromise = loadStripe(
// 	'pk_test_51ROByHQo8ycipebQLD7Yyyexq0LKbCicdMIikzWubHcypcJxZ7wzJFehhT72WgVmAhsvdVH7bfv0qOAKOMSDxEkx00Ti93dUXU'
// ); // Replace with your key

const StripePaymentForm: React.FC = () => {
	const { t } = useTranslation();
	const [stripePromise, setStripePromise] = useState<Stripe | null>(null);
	const { token, reservation, propertyInfo } = useAppSelector(selectSession);
	const [searchParams] = useSearchParams();
	const [refNo, setRefNo] = useState('');

	const dispatch = useAppDispatch();
	const { stages, stage } = useAppSelector(selectStage);
	const [__, setTotalPay, TotalPay] = useState(0.0);

	const [____, setLoading, loading] = useState(false);

	const { reservationDtl, loadingReservation } = useAppSelector(selectTnc);
	const { skipPayment } = useAppSelector(selectPayment);

	const [clientSecret, setClientSecret] = useState<string | undefined>(
		undefined
	);

	const createPaymentIntent = async () => {
		try {
			const { data } = await StripeCreatePaymentIntent(token, {
				amount: 100,
				currency: propertyInfo.currency,
				description:
					'paymentIntent#' +
					reservation.PmsConfirmationNo +
					'-' +
					reservation.LastName,
				confirmationNumber: reservation.PmsConfirmationNo,
				customerId: reservation.ReservationNameID,
			});

			console.log('###############', data);
			setClientSecret(data.clientSecret);
			const stripe = await loadStripe(data.stripePromise);
			setStripePromise(stripe);
		} catch (error) {
			toast.error(t('StripePaymentIntentCreationError'), { autoClose: 10000 });
		}
	};
	useEffect(() => {
		if (skipPayment) {
			dispatch(
				skipStage({
					token: token,
					stageID: stage?.stepID,
					ReservationID: reservation?.ReservationID,
					type: 'checkin',
					confirmationNo: reservation?.PmsConfirmationNo,
					stages: stages,
				})
			);
		}
	}, [skipPayment]);
	useEffect(() => {
		setLoading(true);
		if (reservation?.PmsConfirmationNo && token) {
			dispatch(
				getReservationFromPMS({
					token,
					confirmationNo: reservation.PmsConfirmationNo,
				})
			)
				.unwrap()
				.then(() => {
					fetchPayment();
				});
		}
	}, [reservation?.PmsConfirmationNo, token]);
	useEffect(() => {
		if (reservationDtl) {
			setTotalPay(
				parseFloat(reservationDtl?.balanceAmount ?? 0) +
					parseFloat(reservationDtl?.totalAmount)
			);
		}
	}, [reservationDtl]);

	const appearance: Appearance = {
		theme: 'stripe',
	};

	const options: StripeElementsOptions = {
		clientSecret,
		appearance,
	};

	const fetchPayment = async () => {
		if (TotalPay?.current > 0) {
			createPaymentIntent();
		} else {
			setLoading(true);

			dispatch(
				completeStage({
					token: token,
					stageID: stage?.stepID,
					ReservationID: reservation?.ReservationID,
					type: 'checkin',
					confirmationNo: reservation?.PmsConfirmationNo,
					stages: stages,
					propertyCode: propertyInfo?.propertyCode ?? '', //added new
				})
			)
				.unwrap()
				.then(() => {
					setLoading(false);
				});
			dispatch(display(true));
		}
	};

	return (
		<div
			id="paymentDiv"
			className="d-flex flex-column m-0 p-0"
			style={{
				minHeight: '101vh',
				overflowY: 'auto',
				WebkitOverflowScrolling: 'touch',
			}}>
			<div
				className="d-flex align-items-center justify-content-center text-white"
				style={{
					minHeight: '57px',
					background: '#03355C',
					marginTop: '-8px',
					marginBottom: '8%',
				}}>
				<p
					className="fs-2 m-0"
					style={{
						color: 'white',
						fontSize: 'x-large',
						alignItems: 'center',
						paddingTop: '0.5%',
						textAlign: 'center',
					}}>
					Payment
				</p>
			</div>

			<div
				style={{
					width: '100%',
					// maxWidth: '400px',
					margin: '0 auto',
					padding: '20px',
					backgroundColor: '#f9f9f9',
					borderRadius: '12px',
					boxShadow: '0 0 10px rgba(0,0,0,0.1)',
				}}>
				{!clientSecret ? (
					<div style={{ textAlign: 'center', padding: '2rem' }}>
						<div className="spinner" />
						<p>Loading payment details...</p>
					</div>
				) : (
					<>
						<div style={{ marginBottom: '15px', textAlign: 'center' }}>
							<label
								style={{ fontWeight: '600', fontSize: '1rem', color: '#333' }}>
								Amount to Pay:
							</label>
							<div
								style={{
									fontSize: '1.2rem',
									color: '#2b6cb0',
									fontWeight: '700',
								}}>
								{TotalPay?.current.toFixed(2)}
							</div>
						</div>

						<Elements stripe={stripePromise} options={options}>
							<PaymentElement />
							<StripeForm />
						</Elements>
					</>
				)}
			</div>
		</div>
	);
};

export default StripePaymentForm;
